import { useEffect, useState } from 'react';
import { useGlobal } from '@/utils/useGlobal';

interface UseSwiperAnimateOptions {
    list: string[];
    swiperClassName?: string;
}

let animationId: any = null;
const duration = 4000; // 动画持续时间（毫秒）
let initAniTime = 0; // 开启动画的时间
let aniFrameTime = 0; // 每一帧动画进入时间
let pause = false; // 用户交互鼠标移入是否暂停
let percent = 0; // 进度
let replay = false; // 暂停后继续播放
let enterTime = 0; // 鼠标移入时间
let leaveTime = 0; // 鼠标移出时间
const useSwiperAnimate = ({ list, swiperClassName }: UseSwiperAnimateOptions) => {
    const { gtm } = useGlobal();
    const [swiper, setSwiper] = useState<any>({});
    const changeSwiper = (swiper: any) => setSwiper(swiper);
    const slideChangeHandle = (index: number) => {
        initAniTime = 0;
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
        doAnimate();
        const item = list[index - 1];
        if (item) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'view_banner',
                banner_name: item,
                position: `carousel banner_${index}`,
                nonInteraction: false,
            });
        }
    };
    const hanldleMouseEnter = () => {
        if (swiper) {
            pause = true;
            replay = false;
            enterTime = new Date().getTime();
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
        }
    };
    const hanldleMouseLeave = () => {
        if (swiper) {
            pause = false;
            replay = true;
            leaveTime = new Date().getTime();
            doAnimate();
        }
    };

    // 执行动画的函数
    const animate = () => {
        if (!initAniTime) {
            initAniTime = new Date().getTime();
        }
        aniFrameTime = new Date().getTime();
        const element = document.querySelector(`.${swiperClassName} .swiper-pagination .swiper-pagination-bullet-active .after`) as HTMLSpanElement;
        // 计算动画进度（0 到 1 之间的值）
        if (element && swiper) {
            if (!pause) {
                if (replay) {
                    initAniTime = initAniTime + (leaveTime - enterTime);
                    leaveTime = 0;
                    enterTime = 0;
                    replay = false;
                }
                const judgeTime = aniFrameTime - initAniTime;
                const progress = Math.min(judgeTime / duration, 1);
                percent = progress;
                element.style.transform = `translateX(-${100 - 100 * percent}%)`;
                if (judgeTime >= duration) {
                    try {
                        swiper && swiper.slideNext && swiper.slideNext();
                    } catch (e: any) {}
                }
            } else {
                element.style.transform = `translateX(-${100 - 100 * percent}%)`;
            }
            requestAnimationFrame(animate);
        }
    };

    const doAnimate = () => {
        if (animationId) cancelAnimationFrame(animationId);
        animationId = requestAnimationFrame(animate);
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && swiper && list.length > 0) {
            // 启动动画
            doAnimate();
        }
    }, [swiper, list]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const eles: any = document.querySelectorAll(`.${swiperClassName} .swiper-pagination .swiper-pagination-bullet`);
            for (let i = 0; i < eles?.length; i++) {
                const existedSpan = eles[i].querySelector('.after') as HTMLSpanElement;
                if (!existedSpan) {
                    const span = document.createElement('span');
                    span.setAttribute('class', 'after');
                    eles[i].appendChild(span);
                }
            }
        }
    }, [swiperClassName]);

    return {
        changeSwiper,
        slideChangeHandle,
        hanldleMouseEnter,
        hanldleMouseLeave,
    };
};

export default useSwiperAnimate;
